import { array, function as function_, option } from "fp-ts";

import type { ImageEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "images";

const URLS = {
  create: [BASE_URL, "upload"].join(SLASH),
  delete: (imageId: ImageEntity.Schema["id"]) => [BASE_URL, imageId].join(SLASH),
  getMany: [BASE_URL, "all"].join(SLASH),
};

function getImageUrl(apiUrl: string, id: ImageEntity.Schema["id"]) {
  return [apiUrl, "images", id].join(SLASH);
}

function extractImageIdFromUrl(apiUrl: string, url: string) {
  return function_.pipe(
    url.substring(apiUrl.length + 1),
    (path) => path.split(SLASH),
    array.lookup(1),
    option.map(Number),
    option.flatMap(option.fromPredicate((id) => !isNaN(id))),
    (maybeId) => (option.isSome(maybeId) ? maybeId.value : null),
  );
}

export { extractImageIdFromUrl, getImageUrl, URLS };
